import React from 'react'
import { Dropdown } from 'semantic-ui-react'
import axios from 'axios'

function on_class_room_selected(selected_class_room){

    const url = "/api/set_selected_classroom"
    axios.post(url, { selected_class_room_id: selected_class_room })
        .then(response => {
            // alert("success");  
            // Can show save dialog now incase he has tried to save when he was not signed in yet
          }
        )
        .catch(error => {        
          if (confirm(l.error_try_again + ' ?')) on_class_room_selected(selected_class_room);
    })
}

const ClassRooms = (props) => (
  <div id="classrooms_dropdown"style={{display: 'inline-block'}}>
  <span style={{color: '#21ba45', marginRight: 3}}>{l.classroom + ' '} </span>  
  <Dropdown onChange= {(e, data)=>on_class_room_selected(data.value)} pointing='top' inline defaultValue={props.selected_class_room_id}  options={props.class_rooms} />
  </div>
)

export default ClassRooms
